import { Injectable } from "@angular/core";
import {
  IngredientAssociation,
  IngredientAssociationAiApplyInput,
  IngredientAssociationAiApplyResponse,
  IngredientAssociationAiGenerationResponse,
  IngredientAssociationAiLanguage,
  IngredientAssociationAiReviewResponse,
  NewIngredientAssociation,
  UpdateIngredientAssociation
} from '../../shared/models/ingredientAssociation.model';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class IngredientAssociationService {
  private static readonly BASE_URL = `${environment.apiUrl}/ingredient-association`;

  constructor(private http: HttpClient) {}

  // GET /ingredient-association?fromId=123 (optional)
  getAssociations(fromId?: number): Observable<IngredientAssociation[]> {
    let params = new HttpParams();
    if (fromId != null) {
      params = params.set('fromId', String(fromId));
    }
    return this.http.get<IngredientAssociation[]>(
      IngredientAssociationService.BASE_URL,
      { params }
    );
  }

  // GET /ingredient-association/:id
  getAssociationById(id: number): Observable<IngredientAssociation> {
    return this.http.get<IngredientAssociation>(
      `${IngredientAssociationService.BASE_URL}/${id}`
    );
  }

  // POST /ingredient-association
  addAssociation(data: NewIngredientAssociation): Observable<IngredientAssociation> {
    return this.http.post<IngredientAssociation>(
      IngredientAssociationService.BASE_URL,
      data
    );
  }

  // PUT /ingredient-association/:id
  updateAssociation(patch: UpdateIngredientAssociation): Observable<IngredientAssociation> {
    return this.http.put<IngredientAssociation>(
      `${IngredientAssociationService.BASE_URL}/${patch.association_id}`,
      patch
    );
  }

  // DELETE /ingredient-association/:id
  deleteAssociation(id: number): Observable<void> {
    return this.http.delete<void>(
      `${IngredientAssociationService.BASE_URL}/${id}`
    );
  }

  generateAssociationsWithAi(
    ingredient_id: number,
    language: IngredientAssociationAiLanguage
  ): Observable<IngredientAssociationAiGenerationResponse> {
    return this.http.post<IngredientAssociationAiGenerationResponse>(
      `${IngredientAssociationService.BASE_URL}/ai/generate`,
      { ingredient_id, language }
    );
  }

  applyAiSuggestions(
    associations: IngredientAssociationAiApplyInput[]
  ): Observable<IngredientAssociationAiApplyResponse> {
    return this.http.post<IngredientAssociationAiApplyResponse>(
      `${IngredientAssociationService.BASE_URL}/ai/apply`,
      { associations }
    );
  }

  reviewAssociationWithAi(
    associationId: number,
    language: IngredientAssociationAiLanguage
  ): Observable<IngredientAssociationAiReviewResponse> {
    return this.http.post<IngredientAssociationAiReviewResponse>(
      `${IngredientAssociationService.BASE_URL}/${associationId}/ai-review`,
      { language }
    );
  }
}
